import axiosInstance from "../../utility/axiosInstance";

export interface OnboardingClient {
  id: string;
  name: string;
  slug: string;
  contactEmail: string;
  contactPhone: string | null;
  representativeFirstName: string;
  representativeLastName: string;
  representativeEmail: string;
  representativeRole: string | null;
  onboardingStatus: string;
  onboardingDeadline: string | null;
  lastOnboardingActivityAt: string | null;
  onboardingResumptionStep: string | null;
  onboardingNudgeCount: number;
  onboardingNudgeSentAt: string | null;
  createdAt: string;
  updatedAt: string;
  representativeName: string;
}

export interface OnboardingAnalytics {
  totalClients: number;
  activeOnboardingCount: number;
  completedOnboardingCount: number;
  pendingOnboardingCount: number;
  disapprovedOnboardingCount: number;
  statusBreakdown: Record<string, number>;
  deadlines: {
    overdue: number;
    withinDeadline: number;
    noDeadline: number;
  };
  nudgesAndActivity: {
    highNudgeCount: number;
    staleOnboardingCount: number;
  };
  internalApprovals: {
    ctoSignUpApprovedCount: number;
    ceoSignUpApprovedCount: number;
    ceoDocsApprovedCount: number;
    goLivePendingApprovalCount: number;
  };
  averageCompletionDays: number;
}

export interface OnboardingClientDetails {
  client: OnboardingClient & {
    onboardingApprovedByCTO: boolean;
    onboardingApprovedByCEO: boolean;
    ceoApprovedDocs: boolean;
    goLiveApprovedByIT: boolean;
    goLiveApprovedByCEO: boolean;
    goLiveApprovedByCTO: boolean;
    goLiveApprovedByClient: boolean;
    progressReportUrl: string | null;
    postOnboardAgreementStatus: string;
    postOnboardAgreementSentAt: string | null;
    postOnboardAgreementAcceptedAt: string | null;
    postOnboardAgreementReminderCount: number;
  };
  metrics: {
    daysInCurrentStep: number;
    daysRemainingDeadline: number | null;
    isOverdue: boolean;
    approvalsCount: number;
    totalApprovalsRequired: number;
  };
}

export const onboardingService = {
  getClients: async (params?: Record<string, any>) => {
    const response = await axiosInstance.get<{
      status: string;
      message: string;
      data: OnboardingClient[];
      error: any;
    }>("/onboarding/clients", { params });
    return response.data;
  },

  getAnalytics: async () => {
    const response = await axiosInstance.get<{
      status: string;
      message: string;
      data: OnboardingAnalytics;
      error: any;
    }>("/onboarding/analytics");
    return response.data;
  },

  getClientById: async (id: string) => {
    const response = await axiosInstance.get<{
      status: string;
      message: string;
      data: OnboardingClientDetails;
      error: any;
    }>(`/onboarding/clients/${id}`);
    return response.data;
  },
};
